import engineerList from "./engineerList.vue";
import clientList from "./clientList.vue";
import engineerListAll from "./engineerListAll.vue";
import clientListAll from "./clientListAll.vue";
import edit from "./edit.vue";
import editAll from "./editAll.vue";
let a = Object.assign({ engineerList, clientList, edit, engineerListAll, clientListAll, editAll });
export default a;